import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeApprover: {
		id: 'software-releases-approvers.task-approver.approval-drawer.remove-approver.remove-approver',
		defaultMessage: 'Remove approver',
		description: 'A label for the remove approver button',
	},
	removeApproverFailed: {
		id: 'software-releases-approvers.task-approver.approval-drawer.remove-approver.remove-approver-failed',
		defaultMessage: 'Failed to remove the approver. Please re-try.',
		description: 'The flag message to show when removing the approver failed',
	},
});
